module.exports = __webpack_public_path__ + "static/img/areaA-35.0a0d17a.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character1/ワンダー系/areaA-35.png
// module id = 958
// module chunks = 1